// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__RVqSw","transparent":"Backdrop_transparent__IhUHY"};